// extracted by mini-css-extract-plugin
module.exports = {"QuizTimer":"QuizTimer_QuizTimer__Fi0YS","Red":"QuizTimer_Red__3woTY"};